import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-repeat",
  "use": "icon-repeat-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-labelledby=\"repeatIconTitle\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-linejoin=\"miter\" fill=\"none\" id=\"icon-repeat\"> <title id=\"icon-repeat_repeatIconTitle\">Repeat</title> <path d=\"M2 13.0399V11C2 7.68629 4.68629 5 8 5H21V5\" /> <path d=\"M19 2L22 5L19 8\" /> <path d=\"M22 9.98004V12.02C22 15.3337 19.3137 18.02 16 18.02H3V18.02\" /> <path d=\"M5 21L2 18L5 15\" /> </symbol>"
});
var result = sprite.add(symbol);
export default symbol